module.exports = __webpack_public_path__ + "static/media/americanexpress.69e8f164.png";